module.exports = __webpack_public_path__ + "img/check--pink.8587b9b3.svg";